import { apiClient } from './axios';

import type {
  PaginatedResponse,
  ReportRecord,
  ReportQuery,
  CreateReportDto,
} from '@repo/shared-types';

export const reportsApi = {
  /**
   * Get all reports with pagination and filters
   */
  getReports: async (query: Partial<ReportQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<ReportRecord>>('/reports', {
      params: query,
    });
    return response.data;
  },

  /**
   * Get a single report by ID
   */
  getReport: async (id: string) => {
    const response = await apiClient.get<ReportRecord>(`/reports/${id}`);
    return response.data;
  },

  /**
   * Generate a new report for a given week range
   */
  createReport: async (data: CreateReportDto) => {
    const response = await apiClient.post<ReportRecord>('/reports', data);
    return response.data;
  },

  /**
   * Delete a report by ID
   */
  deleteReport: async (id: string) => {
    await apiClient.delete(`/reports/${id}`);
  },
};
